import escape from 'lodash-es/escape';
import qs from 'qs';

import urls from 'src/urls';

export const buildSocialAuthLinkWithRedirect = (next = '/') => {
  const search = {
    next,
  };

  return escape(`${urls.external.socialAuthLink}?${qs.stringify(search)}`);
};
